import { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import Header from "@/components/Header";
import { extractSessionFromUrl, updatePassword } from "@/lib/supabaseAuth";

const CambiarContrasena = () => {
  const navigate = useNavigate();
  const [accessToken, setAccessToken] = useState("");
  const [password, setPassword] = useState("");
  const [message, setMessage] = useState("");
  const [error, setError] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);

  useEffect(() => {
    const session = extractSessionFromUrl();
    if (session?.access_token) {
      setAccessToken(session.access_token);
      window.history.replaceState(null, "", "/cambiar-contrasena");
    }
  }, []);

  const handleSubmit = async (event) => {
    event.preventDefault();
    setIsSubmitting(true);
    setError("");
    setMessage("");

    try {
      await updatePassword({ accessToken, password });
      setMessage("Contraseña actualizada. Ya puedes iniciar sesion.");
      setTimeout(() => navigate("/iniciar-sesion"), 1800);
    } catch (authError) {
      setError(authError.message);
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <>
      <Header />
      <main className="min-h-screen bg-slate-50 px-4 py-24">
        <div className="mx-auto max-w-md rounded-xl border border-slate-200 bg-white p-6 shadow-sm">
          <h1 className="text-2xl font-black text-slate-950">
            Cambiar contraseña
          </h1>

          {!accessToken ? (
            <div className="mt-4 rounded-lg bg-orange-50 p-4 text-sm font-semibold leading-6 text-orange-900">
              Abre esta pagina desde el enlace de recuperacion que te enviamos por correo.
            </div>
          ) : (
            <form onSubmit={handleSubmit} className="mt-6 space-y-3">
              <input
                required
                minLength={8}
                type="password"
                placeholder="Nueva contraseña"
                value={password}
                onChange={(event) => setPassword(event.target.value)}
                className="w-full rounded-lg border border-slate-200 p-3 outline-none focus:border-[#0056D2]"
              />

              {error && <p className="rounded-lg bg-red-50 p-3 text-sm font-semibold text-red-700">{error}</p>}
              {message && <p className="rounded-lg bg-emerald-50 p-3 text-sm font-semibold text-emerald-700">{message}</p>}

              <button
                type="submit"
                disabled={isSubmitting}
                className="w-full rounded-lg bg-[#F97316] p-3 font-black text-white disabled:bg-orange-300"
              >
                {isSubmitting ? "Guardando..." : "Guardar contraseña"}
              </button>
            </form>
          )}

          <Link to="/iniciar-sesion" className="mt-4 block text-center text-sm font-black text-[#0056D2]">
            Ir a iniciar sesion
          </Link>
        </div>
      </main>
    </>
  );
};

export default CambiarContrasena;
